<template>
  <section class="content">
    <div class="row">
      <div class="col-md-3">
        <MenuMailbox />
      </div>
      <!-- /.col -->
      <div class="col-md-9">
        <Mailbox />
      </div>
    </div>
    <!-- /.row -->
  </section>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import MenuMailbox from "./MenuMailbox";
import Mailbox from "./Mailbox";
// import i18n from "../../lang";
// import utils from '@/lib/utils';

export default {
  name: "ManagementMailbox",
  data() {
    return {};
  },
  watch: {},
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW"
    ])
  },

  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST"
    ])
  },
  mounted() {},

  components: {
    MenuMailbox,
    Mailbox
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Mailbox/ManagementMailbox.vue